import { css } from '@emotion/react';
import { WIDTH_NAVIGATION_VIEW } from '@pages/Main/MainView/constants';

export const container = css({
  width: 1920 - WIDTH_NAVIGATION_VIEW,
  position: 'absolute',
  top: 0,
  left: 0,
  flexDirection: 'row',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: 72,
  marginLeft: WIDTH_NAVIGATION_VIEW,
  zIndex: -1
});

export const text = css({
  fontWeight: 700,
  fontSize: 24,
  color: 'white'
});

export const logo = css({
  marginRight: 64
});
